// Constants
import { LANG } from "@/constants/languages.ts";
// Utils
import { loadStorageItem } from "@/utils/common.ts";
// Types
import type { Locale } from "vue-i18n";

export function getLocalLanguage(): Locale {
  const storageLanguage = loadStorageItem("lang");

  if (storageLanguage) {
    return storageLanguage as Locale;
  }

  const systemLanguage = navigator.language;

  if (!systemLanguage) {
    return LANG.EN;
  }

  return isFinnishLanguage(systemLanguage) ? LANG.FIN : LANG.EN;
}

export function isFinnishLanguage(language: string): boolean {
  return /fi/gi.test(language);
}
